import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy for COIN</h1>
        <p className="effective-date">Effective Date: 2/1/2025</p>
        <p className="effective-date">Last Updated: 9/2/2026</p>
        
        <p>COIN ("Company," "we," "us," or "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains what information we collect, how we use it, and your rights under applicable laws, including the California Consumer Privacy Act (CCPA/CPRA).</p>
        <p>By using COIN, you agree to the terms of this Privacy Policy.</p>

        <h2>1. Important Notice for Non-U.S. Users</h2>
        <p>COIN is exclusively for U.S.-based customers. If you reside in the European Union (EU) or any jurisdiction subject to the General Data Protection Regulation (GDPR), you are prohibited from using this site or providing any personal information.</p>
        <p>We do not market to, target, or knowingly collect data from individuals in the EU. If we become aware that an EU resident has provided personal data, we will delete it immediately upon discovery.</p>
        <p>By continuing to use this site, you confirm that you are not an EU resident and understand that COIN is not designed to be GDPR-compliant.</p>
        <p>If you believe we have collected your data in error, please contact us at support@cardboardprofit.com to request deletion.</p>

        <h2>2. Information We Collect</h2>
        <p>We collect the following types of information:</p>
        <p><strong>a) Information You Provide to Us</strong></p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Username and encrypted password (we do not store or have access to your actual password)</li>
        </ul>
        <p><strong>b) Automatically Collected Data</strong></p>
        <p>When you use COIN, we may automatically collect:</p>
        <ul>
          <li>IP address</li>
          <li>Device & browser information</li>
          <li>Usage data (e.g., pages visited, time spent on site, interactions with features)</li>
          <li>Anonymous search terms used in Quick Flip Search to improve the tool; if you are signed in, we also count how many searches your account runs and when, without linking your search terms to your account</li>
          <li>Referral data (e.g., whether you arrived via an ad, social media, or another website)</li>
          <li>Cookies & tracking technologies (see Section 6)</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>We use the information collected to:</p>
        <ul>
          <li>Provide and improve our services</li>
          <li>Allow you to log in and manage your account</li>
          <li>Send service-related updates and promotional emails (you can opt out anytime)</li>
          <li>Analyze site usage to improve COIN (Google Analytics may be used in the future)</li>
          <li>Track conversions and serve relevant ads (Meta Pixels)</li>
          <li>Process affiliate links (eBay purchases may generate commissions for us)</li>
          <li>Support a future refer-a-friend program</li>
        </ul>

        <h2>4. How We Share Your Information</h2>
        <p><strong>AI connections you authorize.</strong> If you approve a COIN AI connection, the third-party client can receive the COIN research returned by tools it calls within the approved scopes. We keep a record of the client, scopes, and connection activity so you can review and revoke access. We do not give the client your COIN password or payment details. The client&apos;s own privacy terms govern its handling of the research it receives. You can disconnect individual clients from AI Connections in your account.</p>
        <p>We do not sell your personal data.</p>
        <p><strong>No Third-Party Data Sales</strong></p>
        <p>We do not sell personal data to third parties. While we use services such as Meta Pixels, Stripe, and eBay affiliate tracking, these companies process data according to their own privacy policies, and by using COIN you consent to such processing.</p>
        <p><strong>Examples of Third-Party Data Processing</strong></p>
        <ul>
          <li>Payment Processor (Stripe): Payments are securely handled by Stripe, and we do not store credit card information.</li>
          <li>Marketing & Analytics Tools: We use Meta Pixels and may use Google Analytics in the future for marketing and site improvements.</li>
          <li>Affiliate Links (eBay): Clicking on affiliate links may result in cookies being placed to track purchases.</li>
          <li>Legal & Compliance: If required by law, we may share data with authorities.</li>
        </ul>

        <p><strong>Meta Conversions API</strong></p>
        <p>In addition to using Meta's Pixel, we may also send hashed user data (such as email address) directly to Meta using their Conversions API. This helps us better measure the effectiveness of our advertising campaigns and ensure accurate attribution. This data is hashed before transmission and is used only for matching purposes within Meta's systems.</p>

        <h2>5. Your Rights & Choices</h2>
        <p>If you are in California (CCPA), you have the right to:</p>
        <ul>
          <li>Opt out of marketing emails (click 'Unsubscribe' or email support@cardboardprofit.com). Service-related emails cannot be opted out of.</li>
          <li>Access, correct, or delete your personal data</li>
          <li>Opt out of tracking and targeted advertising</li>
          <li>Request that we do not sell your personal data (we don't anyway)</li>
          <li>Receive a copy of your data</li>
        </ul>
        <p>To exercise these rights, email us at support@cardboardprofit.com.</p>

        <h2>6. Cookies & Tracking Technologies</h2>
        <p>We use cookies and tracking technologies to:</p>
        <ul>
          <li>Improve your experience on COIN</li>
          <li>Track ad performance and user interactions (Meta Pixels)</li>
          <li>Analyze site usage (Google Analytics, if implemented)</li>
        </ul>
        <p><strong>Opting Out of Tracking & Ads</strong></p>
        <p>You can opt out of tracking by adjusting your browser settings or using the following links:</p>
        <ul>
          <li>Meta Ad Tracking: [Meta Ad Preferences]</li>
          <li>Google Analytics: [Google Analytics Opt-Out]</li>
        </ul>
        <p>Disabling cookies may impact your experience on COIN.</p>

        <h2>7. Data Deletion Requests</h2>
        <p>Users may request deletion of their personal data by contacting us at support@cardboardprofit.com. Upon receiving a request, we will delete your data unless we are legally required to retain it (e.g., for fraud prevention, tax compliance, or other regulatory obligations).</p>

        <h2>8. Data Transfers & Storage</h2>
        <p>Your data may be stored on servers located in the United States or other jurisdictions. By using COIN, you consent to your data being stored and processed in these locations.</p>

        <h2>9. Children's Privacy (COPPA Compliance)</h2>
        <p>COIN is not intended for users under 13 (or under 16 in some jurisdictions). We do not knowingly collect data from children. If you believe a child has provided us with personal data, please contact us to delete it.</p>

        <h2>10. Data Security & Retention</h2>
        <p>We implement security measures to protect your data.</p>
        <p>We retain your data for as long as your account is active or as necessary to provide services. If you cancel your account, we may retain your data for up to 12 months for record-keeping, fraud prevention, or legal compliance, and for longer where legally required.</p>

        <h2>11. Changes to This Privacy Policy</h2>
        <p>We may update this policy from time to time. Changes will be posted on this page with the "Last Updated" date.</p>

        <h2>12. Contact Us</h2>
        <p>For any questions about this policy or your data, contact us at:</p>
        <ul>
          <li>📩 Email: support@cardboardprofit.com</li>
          <li>🌍 Website: thecardboardcoin.com</li>
        </ul>

        <p>By using COIN, you acknowledge that you have read and agree to this Privacy Policy.</p>

        <Link to="/" className="back-link">Back to Home</Link>
      </div>
    </div>
  );
}

export default Privacy;
